import { render } from "./AppKurumsal.vue?vue&type=template&id=2182bbdb&scoped=true"
import script from "./AppKurumsal.vue?vue&type=script&lang=js"
export * from "./AppKurumsal.vue?vue&type=script&lang=js"

import "./AppKurumsal.vue?vue&type=style&index=0&id=2182bbdb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2182bbdb"]])

export default __exports__